export const homeMenu = [
    { index: 0, name: 'Home' },
    { index: 1, name: 'Economy' },
    { index: 2, name: 'Ecology' },
    { index: 3, name: 'Game' },
    { index: 4, name: 'WhitePaper' },
    { index: 5, name: 'Launch App' },
];

export const homeSectionPaths: Record<number, string> = {
    0: '/home',
    1: '/home/economy',
    2: '/home/cology',
    3: '/home/game',
};

const homeSectionAliases: Record<string, number> = {
    '/': 0,
    '/home': 0,
    '/home/economy': 1,
    '/home/cology': 2,
    '/home/ecology': 2,
    '/home/game': 3,
};

export const getHomeSectionPath = (index: number): string => homeSectionPaths[index] || '/home';

export const getHomeSectionIndexByPath = (path: string): number | undefined => {
    const normalizedPath = path.replace(/\/+$/, '') || '/';
    return homeSectionAliases[normalizedPath];
};

export const isHomeSectionPath = (path: string): boolean => getHomeSectionIndexByPath(path) !== undefined;

//个人中心菜单
export const adminMenu = [
    {
        index: 0,
        name: 'App Center',
        path: '/admin/home',
        permission: 'all',
    },

    {
        index: 1,
        name: 'AIcade Point',
        path: '/admin/point',
        permission: 'all',
    },
    {
        index: 2,
        name: 'TOKEN',
        path: '/admin/token',
        permission: 'all',
    },
    {
        index: 3,
        name: 'MINT',
        path: '/admin/mint',
        permission: 'all',
    },
    {
        index: 4,
        name: 'Loan',
        path: '/admin/loan',
        permission: 'all',
    },
    {
        index: 5,
        name: 'Swap',
        path: '/admin/swap',
        permission: 'all',
    },
    {
        index: 6,
        name: 'Dapp Management',
        path: '/admin/management',
        permission: 'hasGameOwner',
    },
    {
        index: 7,
        name: 'Token Management',
        path: '/admin/token-management',
        permission: 'hasTokenOwner',
    },
    {
        index: 8,
        name: 'Service Management',
        path: '/admin/service-management',
        permission: 'hasGameOwner',
    },
    {
        index: 9,
        name: 'APIKey Management',
        path: '/admin/api-key-management',
        permission: 'all',
    },
];
